import { ResumeBuilder } from 'types/reducers/resumeBuilder';

import { ResumeBuilderSchema } from 'components/resumeBuilder/steps/schema';
import { RB_THEME } from 'components/resumeBuilder/template/themes/info';

export const RESUME_BUILDER_INITIAL_STATE: ResumeBuilder = {
  resumeBuilderState: ResumeBuilderSchema,
  flow: {
    visitedSteps: [],
    currentStepIndex: 0,
    currentSubStepIndex: 0,
    nextBtnLabel: 'Next',
  },
  theme: RB_THEME.THEME_1,
  professionalSummary: {},
  previewModalInfo: {
    open: false,
    template: '',
  },
  previewStepCompletedSectionsModal: {
    open: false,
    filledSteps: [],
    unfilledSteps: [],
  },
  myResumePage: false,
  templatePresetChosen: false,
  templatePresetSelected: false,
  templateInMobileCarousel: false,
  id: '',
  topResumeFlag: true,
  isCompleted: false,
};
